var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgTabbyCare = function SvgTabbyCare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#5D21DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.97 15.764 2.527 2.527 9.741-9.742a3.574 3.574 0 0 0-5.053 0L7.97 15.764ZM6.288 9.056l-2.527 2.527 3.367 3.367a3.574 3.574 0 0 0 0-5.054l-.84-.84Z",
    fill: "#fff"
  })));
};
var Memo = /*#__PURE__*/memo(SvgTabbyCare);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iMTIiIGZpbGw9IiM1RDIxREUiLz48cGF0aCBkPSJtNy45NyAxNS43NjQgMi41MjcgMi41MjcgOS43NDEtOS43NDJhMy41NzQgMy41NzQgMCAwIDAtNS4wNTMgMEw3Ljk3IDE1Ljc2NFpNNi4yODggOS4wNTZsLTIuNTI3IDIuNTI3IDMuMzY3IDMuMzY3YTMuNTc0IDMuNTc0IDAgMCAwIDAtNS4wNTRsLS44NC0uODRaIiBmaWxsPSIjZmZmIi8+PC9zdmc+";